<template>
    <div class="home-page">
        <Header></Header>
        <!-- 面包屑导航 -->
        <div class="breadcrumbs">
          <div class="breadcrumbs-content m_section_inner disflex">
            <div class="bd-ul">
              <ul class="">
                <li class="home"><a href="./">{{$t('home')}}</a></li>
                <li><span>{{$t('Kanji')}}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_title">
          <div class="m_section_inner" style="background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0)), url(../../static/images/Kanji-Title-Pic.jpg) no-repeat 0 0 / cover ">
            <div class="disflex sub-content">
              <div class="disflex topic-header">
                <div class="topic-titles">
                  <div class="jp fw7">かんじ</div>
                  <div class="jp">{{$t('Kanji')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
		<div class="">
      <div class="content crfff por">
        <div class="kanji-content mt30">
          <div class=""  :id="'Topic'+(index+1)" v-for="(item,index) in list" :key="index">
            <div class="step1 bd disflex" style="padding-bottom: 30px;">
              <div class="step1-num">{{item.title.topic_en}}{{$t('Topic')}}{{index+1}}</div>
              <div class="step1-content">
                <strong>{{item.title.jp_title}}</strong>
                <div><em>{{ item.title.yin_title }}</em>/{{item.title.en_title}}</div>
              </div>
            </div>
            <div class="disflex mt20" style="justify-content: right;margin-right: 20px;width: 90%;">
              <div class="drill_nav">
                  <a @click="back('Topic'+(index+1))"><span>{{$t('Kanji')}}</span><img style="transform: rotate(-90deg);width: 26px;margin-left: 10px;" src="../../static/images/up.png"></a>
              </div>
            </div>
            <div class="" v-for="(item0,key,index0) in item.list">
              <div class="grammar-content mt30">
                <div class="step1 disflex">
                  <div class="step1-num text-shadow">{{key}}</div>
                  <div class="step1-content" style="width: 60%;">
                    {{$t('Choose_the')}}<em class="cr8a570f" style="text-decoration: underline;">{{$t('underlined')}}</em> {{$t('word')}}.
                  </div>
                </div>
              </div>
              <div class="grammar-detail">
                <div class="answer-ul">
                  <ul>
                    <li v-for="(item1,index1) in item0" :key="item1.id" class="kanji-q-li">
                      <div class="as-title disflex">
                        <div class="num">{{item1.ques_num}}</div>
                        <div class="as-t" v-html="item1.title"></div>
                      </div>
                      <ul class="as-ul disflex">
                        <li class="as-li disflex"
                            v-for="(item2,index2) in item1.options"
                            :key="item2.answer_num"
                            @click="selectAnswer(item1, item2, item.id, key)">
                          <div class="input-i" :class="getOptionClass(item1, item2, item.id, key)">
                            <span></span>
                          </div>
                          <div class="as-r">
                            <div class="" v-html="item2.option"></div>
                          </div>
                        </li>
                      </ul>
                      <!-- 当前题目答案显示区域 -->
                     <!-- <div v-if="showCurrentAnswer[item1.id]" class="answer-feedback">
                        <div v-if="userAnswers[item1.id]" class="feedback-text" :class="isAnswerCorrect(item1) ? 'correct' : 'incorrect'">
                          {{ isAnswerCorrect(item1) ? '✓ Correct!' : '✗ Incorrect' }}
                        </div>
                        <div class="correct-answer" v-if="!isAnswerCorrect(item1) && userAnswers[item1.id]">
                          Correct answer: <span v-html="getCorrectAnswer(item1)"></span>
                        </div>
                      </div> -->
                    </li>
                  </ul>
                  <div class="disflex" style="justify-content: center;">
                    <div class="Practice text-shadow mt20"
                         :class="{ disabled: !isPartCompleted(item0, item.id, key) }"
                         @click="showPartAnswers(item0, item.id, key)">
                      {{$t('Answer')}}
                      <img src="../../static/images/up.png">
                    </div>
                    <div class="Practice try-again text-shadow mt20" style="margin-left:20px;" @click="resetPartAnswers(item0, item.id, key)">
                      {{$t('Try Again')}}
                      <img width="28" src="../../static/images/Try-Again-Btn.png">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
		</div>

      <Dialog ref="levelDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
        <div class="invited-c ac" slot="mdBox" style="">
          <div class="invited-l">
            <h2 class="ac mt30 font-family " style="color: #2a2d5a;font-size: 50px"> {{$t('Grammar_tips')}}</h2>
          </div>
          <div class="sure_btn" @click="closeBuyPopup">
            <button class=" btn6 font-family mt20" style="line-height: 103px;color: #fff;font-size: 30px;" >{{$t('OK')}}</button>
          </div>
        </div>
      </Dialog>

	</div>
</template>

<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'

export default {
    components: {
        Header, Dialog
    },
    data() {
      return {
        list: [],
        typeList: [],
        type: '',
        info: {},
        // 状态管理
        userAnswers: {}, // 存储用户答案 {题目id: 选择的答案编号}
        showCurrentAnswer: {}, // 存储当前显示的答案 {题目id: boolean}
        answeredQuestions: {} // 存储已答题目 {题目id: boolean}
      }
    },
    mounted() {
      // 在组件挂载后检查URL hash并滚动到对应位置
      this.$nextTick(() => {
        this.scrollToHash();
      });
    },
    watch: {
      // 监听路由变化，当hash变化时滚动到对应位置
      '$route'(to, from) {
        if (to.hash !== from.hash) {
          this.$nextTick(() => {
            this.scrollToHash();
          });
        }
      },
      // 监听list数据加载完成
      'list'() {
        // 数据加载完成后滚动到hash位置
        this.$nextTick(() => {
          this.scrollToHash();
        });
      }
    },
    created() {
      this.getList();
    },
    methods: {
      back(type){
        this.$router.push({path:'/Kanji#'+type,query: {}});
      },
      getToDetail(item) {
        this.$router.push({path: '/KanjiDetail', query: {id: item.id}});
      },
      getList() {
        let that = this;
        that.$parent.loadModal(true);
        that.$api.post('/api/kanji/question', null, r => {
          that.$parent.returnCode(r, function() {
            that.list = r.data;
            // 初始化状态
            that.initializeState();
            that.$parent.loadModal(false);
          });
        });
      },
      // 初始化状态
      initializeState() {
        this.list.forEach(item => {
          if (item.list && typeof item.list === 'object') {
            Object.entries(item.list).forEach(([partKey, questionList]) => {
              if (Array.isArray(questionList)) {
                questionList.forEach(question => {
                  this.$set(this.userAnswers, question.id, null);
                  this.$set(this.showCurrentAnswer, question.id, false);
                  this.$set(this.answeredQuestions, question.id, false);
                });
              }
            });
          }
        });
      },

      // 滚动到hash对应的元素
      scrollToHash() {
        if (this.$route.hash) {
          const hash = this.$route.hash.slice(1); // 去掉#号
          const element = document.getElementById(hash);
          if (element) {
            // 计算元素位置并添加140px偏移
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - 150;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });

            // 备用方案：使用scrollIntoView with offset
            // const yOffset = -150;
            // const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            // window.scrollTo({top: y, behavior: 'smooth'});
          }
        }
      },
      // 选择答案 - 添加 partKey 参数
      selectAnswer(question, option, groupId, partKey) {
        // 如果已经显示答案，则不允许修改
        if (this.showCurrentAnswer[question.id]) {
          return;
        }

        // 记录用户答案
        this.$set(this.userAnswers, question.id, option.answer_num);
        this.$set(this.answeredQuestions, question.id, true);

        // 自动隐藏其他题目的答案显示
        this.hideOtherAnswers(question.id, groupId, partKey);
      },
      // 隐藏其他题目的答案显示
      hideOtherAnswers(currentQuestionId, groupId, partKey) {
        const group = this.list.find(item => item.id === groupId);
        if (group && group.list && group.list[partKey]) {
          group.list[partKey].forEach(question => {
            if (question.id !== currentQuestionId) {
              this.$set(this.showCurrentAnswer, question.id, false);
            }
          });
        }
      },
      // 获取选项样式类 - 添加 partKey 参数
      getOptionClass(question, option, groupId, partKey) {
        const userAnswer = this.userAnswers[question.id];
        const isShowingAnswer = this.showCurrentAnswer[question.id];
        const isSelected = userAnswer === option.answer_num;
        const isCorrectAnswer = option.answer_num === question.question_answer;

        // 如果没有显示答案，只显示选中状态
        if (!isShowingAnswer) {
          return isSelected ? 'active' : '';
        }

        // 显示答案时的状态
        if (isCorrectAnswer) {
          // 正确答案
          return 'correct';
        } else if (isSelected && !isCorrectAnswer) {
          // 用户选择的错误答案
          return 'incorrect';
        }

        // 其他未选中的选项
        return '';
      },
      // 检查答案是否正确
      isAnswerCorrect(question) {
        return this.userAnswers[question.id] === question.question_answer;
      },
      // 获取正确答案
      getCorrectAnswer(question) {
        const correctOption = question.options.find(opt => opt.answer_num === question.question_answer);
        return correctOption ? correctOption.option : '';
      },
      // 检查当前部分是否完成
      isPartCompleted(questionList, groupId, partKey) {
        if (!Array.isArray(questionList)) return false;
        return questionList.every(question => this.answeredQuestions[question.id]);
      },
      // 显示当前部分的答案
      showPartAnswers(questionList, groupId, partKey) {
        if (!Array.isArray(questionList) || !this.isPartCompleted(questionList, groupId, partKey)) {
          return; // 题目未完成，不执行操作
        }

        // 显示该部分所有题目的答案
        questionList.forEach(question => {
          this.$set(this.showCurrentAnswer, question.id, true);
        });
      },
      // 重置当前部分的答案
      resetPartAnswers(questionList, groupId, partKey) {
        if (!Array.isArray(questionList)) return;

        questionList.forEach(question => {
          this.$set(this.userAnswers, question.id, null);
          this.$set(this.showCurrentAnswer, question.id, false);
          this.$set(this.answeredQuestions, question.id, false);
        });
      },
      closeBuyPopup() {
        this.$refs.levelDialog.closeMask();
        this.$router.push({path: '/', query: {}});
      },
      statusText(status) {
        switch (status) {
          case 1: return this.$t('no_start')
          case 2: return this.$t('in_process')
          case 3: return this.$t('finished')
          default: return ''
        }
      }
    }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/page/KanjiAnswer.vue